import { ErrorBoundary, type JSX } from "solid-js";
import { ErrorBoundaryFallback } from "./error-boundary-fallback";

interface DataRegionBoundaryProps {
  children: JSX.Element;
  /** Optional override title for the inline fallback. */
  title?: string;
  /** Optional override description for the inline fallback. */
  description?: string;
}

/**
 * Wraps a data-driven region (a route body, a list, a chart) in a Solid
 * <ErrorBoundary> so a thrown render — e.g. a malformed PowerSync row — degrades
 * to a premium inline fallback with Retry instead of taking down the whole app.
 *
 * Use this around route content; the global boundary in `_app/route.tsx` is the
 * last-resort net for everything else.
 */
export function DataRegionBoundary(props: DataRegionBoundaryProps): JSX.Element {
  return (
    <ErrorBoundary
      fallback={(error: unknown, reset: () => void) => (
        <ErrorBoundaryFallback
          error={error}
          reset={reset}
          inline
          title={props.title}
          description={props.description}
        />
      )}
    >
      {props.children}
    </ErrorBoundary>
  );
}
